module.exports = __webpack_public_path__ + "img/calle.37185e95.jpg";